import { Box, Button, Card, CardActions, CardContent, CardMedia, Chip, Grid, Paper, Skeleton, Stack, TablePagination, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/system';
import SearchBox from '../../../../components/reusableComponents/SearchBox';
import ApiService from '../../../../_services/ApiService';
import { useSelector } from 'react-redux';
import { default_limit, record_limits } from '../../../../_services/_constants/recordLimitset.constant';
import NoResults from '../../../../components/reusableComponents/NoResults';
import SnackbarContainer from '../../../Snackbar';
import { useHistory } from 'react-router-dom';
import SkeletonCard from '../../../../_helpers/reusablefunctions/SkeletonCard';
import playlist from '../../../../img/default-image.png'
import GetMoodGenreLanguage from '../../../../_helpers/reusablefunctions/getMoodGenreLanguage';
import SwitcherBtn from '../../../../components/reusableComponents/SwitcherBtn';
import TableComponent from '../../../../components/Tablecomponent';
import { useLocation } from 'react-router-dom';

const StyledChip = styled(Chip)(({ theme }) => ({
    borderRadius: '10px',
    color: '#545454',
    background: '#fff',
    border: '0px',
    padding: '6px 20px 6px 20px',
    fontSize: '14px',
    flex: 'wrap',
    gap: 2,
    '&:hover': {
        backgroundColor: '#ED1C24',
        color: '#fff',
    },
    '&.MuiChip-clickable:focus, &.MuiChip-clickable:hover': {
        backgroundColor: '#ED1C24',
        color: '#fff',
    },
    '&.MuiChip-clickable': {
        '&.Mui-active': {
            backgroundColor: '#ED1C24',
            color: '#fff',
        },
    },
}));
export default function OfficialPlaylist() {
    const userData = useSelector((state) => state.userData.userData);
    const history = useHistory()
    const location = useLocation();
    const [playlistLists, setplaylistLists] = useState([]);
    const [loader, setLoader] = useState(true);
    const [activeChip, setActiveChip] = useState('0-0');
    const [openRatingDialog, setOpenRatingDialog] = useState(false)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState()
    const [songId, setSongId] = useState('')
    const [searchInput, setSearchInput] = useState('')
    const [viewMode, setViewMode] = useState(true); // 'card' or 'table'

    const filterSongs = [
        { label: 'playlists/', value: ["All Playlist"] },
        { label: 'official', value: ["Official Playlist"] },
        { label: 'trending', value: ["Trending Playlist"] },
        { label: 'getRelatedPlaylist/', value: ["Playlist for you"] },
    ]

    function playlistListsApi(url) {
        setLoader(true)
        const premium_user = userData?.enable_distribution ? 'True' : 'False'
        ApiService.get('allsongslist', { premium_users: premium_user, verified_users: 'Verified', limit: rowsPerPage, offset: page }, url).then(res => {
            const response = res?.data || []
            setLoader(false)
            if (response) {
                setplaylistLists([])
                setplaylistLists(response?.results)
                setTotalCount(response?.total_count)
            }
        }).catch(function (error) {
            console.log(error);
            console.log(error.response);
        });
    }

    function officialtredingPlaylistApi(value) {
        let payload = { search: value, limit: rowsPerPage, offset: page };
        setLoader(true)
        ApiService.get('allPlaylist', payload)
            .then((response) => {
                if (response.status === 200) {
                    setplaylistLists([])
                    let arrayData = response.data.results;
                    const data = arrayData.sort(function (a, b) {
                        return parseInt(a.playlist_order) - parseInt(b.playlist_order);
                    });
                    setplaylistLists(data);
                    setTotalCount(response?.data?.total_count)
                    setLoader(false)
                }
            })
            .catch((error) => {
                console.error(error);
            })
    }

    function getSearchList() {
        const premium_user = userData?.enable_distribution ? 'True' : 'False'
        setLoader(true)
        ApiService.get('searchplaylist', { search: searchInput, limit: rowsPerPage, offset: page, premium_users: premium_user, verified_users: 'Verified' }).then(res => {
            const response = res?.data || []
            setLoader(false)
            if (response) {
                setplaylistLists(response?.results)
                setTotalCount(response?.total_count)
            }
        }).catch(error => {
            console.log(error);
            console.log(error.response);
        })
    }

    useEffect(() => {
        if (searchInput != null && searchInput.length > 0) {
            let delaySearch;
            delaySearch = setTimeout(() => {
                getSearchList()
            }, 1000);
            return () => clearTimeout(delaySearch)
        } else {
            if (userData) {
                playlistListsApi('playlists/')
            }
        }
    }, [userData, page, rowsPerPage, searchInput])

    const handleChipClick = (i, label, value) => {
        setActiveChip(i)
        if (label == "trending" || label == "official") {
            officialtredingPlaylistApi(label)
        } else {

            playlistListsApi(label)
        }
        // history.push(`?tab=${value}`, { value: i, label: label });
    }

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        const newPage = Math.floor((page * rowsPerPage) / newRowsPerPage);
        setRowsPerPage(newRowsPerPage);
        setPage(newPage);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    function openRatingHandler(id) {
        setOpenRatingDialog(true)
        setSongId(id)
    }

    const handleSearchInput = (value) => {
        setSearchInput(value)
    }

    function openReviews(data) {
        history.push("/reviews", { dialogValue: "Playlist", reviewViewDetail: data, preUrl: '/discover-playlist' });
    }

    const openDetails = (data) => {
        history.push(`/discoverplaylistdetail/${data.playlist_id}`, { playlistData: data })
    }

    // Table columns
    const columnsSong = [
        {
            id: 'playlist_cover_image',
            label: 'Playlist Name',
            template: (row) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <CardMedia
                        sx={{ height: 50, width: 50, borderRadius: '8px' }}
                        image={row?.playlist_cover_image ? process.env.REACT_APP_BASEURL_MEDIA + '/media/' + row.playlist_cover_image :
                            row?.playlist_cover_image_url ? row?.playlist_cover_image_url : playlist}
                        title="song-thumbnail"
                        onClick={() => openDetails(row)}
                        style={{
                            cursor: 'pointer'
                        }}
                    />
                    <Typography variant="body2" className='text-truncate'>{row?.playlist_name || '-'}</Typography>
                </Box>
            ),
        },
        {
            id: 'user_name',
            label: 'Name',
            template: (row) => (
                <Typography variant="body2" sx={{ color: 'text.secondary', margin: '8px 0px' }}>
                    {row?.user_name ? 'By-' + row?.user_name || '-' : 'By-GNTunes'}
                </Typography>
            ),
        },
        {
            id: 'playlist_genre',
            label: 'Genre',
            template: (row) => (
                <GetMoodGenreLanguage sliceCount={1} label="" items={row?.playlist_genre || []} />
            ),
        },
        {
            id: 'mood',
            label: 'Mood',
            template: (row) => (
                <GetMoodGenreLanguage sliceCount={1} label="" items={row?.mood || []} />
            ),
        },
        {
            id: 'language',
            label: 'Language',
            template: (row) => (
                <GetMoodGenreLanguage sliceCount={1} label="" items={row?.language || []} />
            ),
        }
    ]

    // ---------------- render card view ----------------
    const renderCardView = () => (
        <Grid container spacing={2} alignItems="stretch">
            {loader ?
                Array.from(new Array(8)).map((item, index) => (<Grid key={index} item xs={12} sm={6} md={3} lg={3} >
                    <SkeletonCard />
                </Grid>))
                :
                loader === false && playlistLists.length === 0 ? (
                    <NoResults message="No Result Found" />
                )
                    :
                    playlistLists.map((data, index) => (
                        <Grid key={index} item xs={12} sm={6} md={3} lg={3} >
                            <Card className='h-100'>
                                <CardMedia
                                    image={data?.playlist_cover_image ? process.env.REACT_APP_BASEURL_MEDIA + '/media/' + data.playlist_cover_image :
                                        data?.playlist_cover_image_url ? data?.playlist_cover_image_url : playlist}
                                    title="song-thumbnail"
                                    onClick={() => openDetails(data)}
                                    sx={{
                                        aspectRatio: '1 / 1',
                                        width: '100%',
                                        objectFit: 'cover',
                                        cursor: 'pointer'
                                    }}
                                />

                                <CardContent>
                                    <Tooltip title={data?.playlist_name}
                                        placement="top"
                                        arrow>
                                        <Typography variant="body2" className='text-truncate'><strong>Name:</strong> {data?.playlist_name || '-'}</Typography>
                                    </Tooltip>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', margin: '8px 0px' }}>
                                        {data?.user_name ? 'By-' + data?.user_name || '-' : 'By-GNTunes'}
                                    </Typography>
                                    {/* <GetMoodGenreLanguage sliceCount={1} label="Genre" items={data?.playlist_genre || []} />
                                    <GetMoodGenreLanguage sliceCount={1} label="Mood" items={data?.mood || []} />
                                    <GetMoodGenreLanguage sliceCount={1} label="Language" items={data?.language || []} /> */}
                                </CardContent>
                            </Card>
                        </Grid>))}
            <TablePagination
                rowsPerPageOptions={record_limits}
                colSpan={3}
                sx={{ width: '100%', marginTop: '20px', padding: '32px 0px 32px 32px' }}
                className='cardPagination'
                component='div'
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Grid>
    )

    // ---------------- render table view ----------------
    const renderTableView = () => {
        if (loader) {
            return (
                <Paper>
                    <Box p={3}>
                        {Array.from(new Array(5)).map((_, index) => (
                            <Skeleton key={index} variant="rectangular" height={60} sx={{ mb: 1 }} />
                        ))}
                    </Box>
                </Paper>
            );
        }

        if (playlistLists.length === 0) {
            return <NoResults message="No Result Found" />;
        }

        return (
            <Paper>
                <TableComponent
                    totalCount={totalCount}
                    setRowsPerPage={setRowsPerPage}
                    rowsPerPage={rowsPerPage}
                    setPage={setPage}
                    page={page}
                    columns={columnsSong}
                    data={playlistLists}
                />
            </Paper>
        );
    };

    return (
        <Box className='container-fluid py-4 px-4 creator-playlist-panel'>
            <Box>
                <h2>Discover-Playlist</h2>
            </Box>
            <Box className="d-flex align-items-center justify-content-between my-4 flex-wrap gap-2">
                <Stack direction="row" spacing={1}>
                    {filterSongs.map((d, i) =>
                        d.value.map((v, index) => (
                            <StyledChip
                                key={`${i}-${index}`}
                                label={v}
                                component="a"
                                variant="outlined"
                                clickable
                                onClick={() => handleChipClick(`${i}-${index}`, d.label, v)}
                                className={activeChip === `${i}-${index}` ? 'Mui-active' : ''}
                            />
                        ))
                    )}
                </Stack>
                <Box className="d-flex align-items-center gap-2">
                    <SwitcherBtn layoutComponent={viewMode} handleLayoutComponent={(currentComp) => setViewMode(currentComp)} />
                    {activeChip == '0-0' && <SearchBox handleSearchInput={handleSearchInput} />}
                </Box>
            </Box>
            <Box className='my-4'>
                <Box className='my-4'>
                    {!viewMode ? renderCardView() : renderTableView()}
                </Box>

            </Box>
            <SnackbarContainer />
        </Box>
    )
} 